import {createStyles, Theme} from "@material-ui/core";
import {blueBackgroundColor, fullViewportColumn, primaryColor, styleColors, topCornerBend, topCornerMask, typography} from "src/main.style";

export const infobankStyle = (theme: Theme) => createStyles({
  container : {
    ...fullViewportColumn,
    backgroundColor: blueBackgroundColor,
  },
  tabs: {
    width: '100%',
    height: '48px',
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-evenly',
    backgroundColor: blueBackgroundColor,
    borderRadius: '35px 35px 0px 0px',
    // ['@media (min-width:724px)']: { // eslint-disable-line no-useless-computed-key
    //   borderRadius: '0px',
    // },
    zIndex:2,
  },
  tabsBackground : {
    width: '100%',
    height: '48px',
    position:'absolute',
    zIndex:1,
  },
  tabsIndicator: {
    backgroundColor: primaryColor,
  },
  tab : {
    ...typography.feedback,
    color: styleColors.greyDark2,
    textTransform: 'uppercase',
  },
  tabSelected : {
    ...typography.feedback,
    color: theme.palette.common.black,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  badge: {
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
    borderRadius: '999px',
    minWidth: '16px',
    padding: '0 4px',
    boxSizing: 'border-box',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    letterSpacing: 0,
    textAlign: 'center',
    fontSize: '12px',
    minHeight: '16px',
    color: styleColors.white,
    height: '16px',
    alignSelf: 'center',
    // Match the visual center of the Metropolis capital letters.
    transform: 'translateY(-0.125rem)',
    lineHeight: 1,
    marginLeft: '6px',
  },
  horizontalController: {
    overflowY: 'hidden',
    overflowX: 'auto',
    height: 'calc(100% - 48px)',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    scrollSnapType: 'x mandatory',
    "&::-webkit-scrollbar": {
      height: 0,  /* Remove scrollbar space */
      background: styleColors.transparent,  /* Optional: just make scrollbar invisible */
    }
  },
  infobankColumn: {
    boxSizing: 'border-box',
    overflowY: 'auto',
    overflowX: 'hidden',
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: 'calc(100vh - 48px)',
    maxHeight: 'calc(100vh - 48px)',
    display: 'flex',
    flexDirection: 'column',
    scrollSnapAlign: 'start',
    backgroundColor:blueBackgroundColor,
  },
  containerTop : topCornerMask,
  containerCorners : topCornerBend(theme),
});



// WEBPACK FOOTER //
// ./src/containers/childinfo/infobank.style.ts